import type { VariationBadgeProps } from "./types-variation-badge";
import { useVariationBadge } from "./use-variation-badge";
import { VariationBadgeView } from "./view-variation-badge";

export function VariationBadge({ value, suffix, testId }: VariationBadgeProps) {
  const vm = useVariationBadge(value);

  return <VariationBadgeView {...vm} suffix={suffix} testId={testId} />;
}

export type * from "./types-variation-badge";
